import { createSelector } from 'reselect';

const selectGlobalHSCodes = (state: any) => state.globalHSCodes;

export const selectGlobalHSCodesCurrentItem = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.current);

export const selectGlobalHSCodesListItems = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.list);

export const selectGlobalHSCodesItemById = (itemId: any) =>
    createSelector(selectGlobalHSCodesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalHSCodesQueryItems = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.query);

export const selectGlobalHSCodesCreatedItem = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.create);

export const selectGlobalHSCodesUpdatedItem = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.update);

export const selectGlobalHSCodesReadItem = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.read);

export const selectGlobalHSCodesDeletedItem = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.delete);

export const selectGlobalHSCodesSearchedItems = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.search);

export const selectGlobalHSCodesItemsCount = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.count);

export const selectGlobalHSCodesItemsFilter = createSelector([selectGlobalHSCodes], (globalHSCodes) => globalHSCodes.filter);